import { AnimatePresence } from 'framer-motion';

interface IModalWrapperProps {
  condition: boolean;
  children: React.ReactElement;
}

const ModalWrapper = ({ condition, children }: IModalWrapperProps) =>
  condition ? <AnimatePresence>{children}</AnimatePresence> : children;

export default ModalWrapper;
